import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import { plaidLoading } from 'common/actions'
import { PlaidStatus } from 'embed/constants'

import ThemeConsumer from 'embed/components/ThemeConsumer'

import SummaryCard from './SummaryCard'

const Checkmark = require('embed/components/ApplicationField/check-green.svg')
const Exclamation = require('./exclamation.svg')

const loadingStyles = require('embed/components/LoadingIndicator/styles')
const styles = require('./styles')

export interface OwnProps {
  showSummaryCard?: boolean
}

export interface Props extends OwnProps {
  dispatchPlaidLoading: (loading: boolean) => void
  plaidStatus: PlaidStatus
}

class PlaidLoadingIndicator extends React.Component<Props> {
  onReturnToApplication = () => {
    this.props.dispatchPlaidLoading(false)
  }

  render() {
    const { plaidStatus, showSummaryCard } = this.props

    switch (plaidStatus) {
      case PlaidStatus.Error:
        return (
          <ThemeConsumer>
            {({ colorBorder, borderRadiusSmall }) => (
              <div
                className={classnames(
                  styles.notice,
                  css(`
                border-color: ${colorBorder} !important;
                border-radius: ${borderRadiusSmall}
              `),
                )}
              >
                <Exclamation /> <strong>Link unsuccessful</strong> Please fill out the form.
              </div>
            )}
          </ThemeConsumer>
        )
      case PlaidStatus.Loading:
        return (
          <div className={styles.container}>
            Pulling information from your bank...
            <div className={styles.loading}>
              <div className={loadingStyles.spinner} />
            </div>
            Don't want to wait?
            <ThemeConsumer>
              {({ colorPrimary }) => (
                <div
                  className={classnames(
                    styles.enterManually,
                    css`
                      color: ${colorPrimary};
                    `,
                  )}
                  onClick={this.onReturnToApplication}
                >
                  Enter your information manually
                </div>
              )}
            </ThemeConsumer>
          </div>
        )
      case PlaidStatus.Success:
        return (
          <ThemeConsumer>
            {({ colorBorder, borderRadiusSmall }) => (
              <div
                className={classnames(
                  styles.notice,
                  css(`
                border-color: ${colorBorder} !important;
                border-radius: ${borderRadiusSmall}
              `),
                )}
              >
                <>
                  <div className={styles.header}>
                    <Checkmark /> <strong>Link successful!</strong>
                  </div>
                  <p>Confirm everything looks correct and add the last details for personalized offers.</p>
                  {showSummaryCard && <SummaryCard />}
                </>
              </div>
            )}
          </ThemeConsumer>
        )
      default:
        return null
    }
  }
}

const mapStateToProps = (state) => ({
  plaidStatus: state.ui?.plaid?.status,
})

const mapDispatchToProps = (dispatch) => ({
  dispatchPlaidLoading: (loading: boolean) => dispatch(plaidLoading(loading)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PlaidLoadingIndicator)
